<template>
	<div class="order-body">
		<div class="fx-header">
			<p>预付货款</p>
		</div>
		<Search :orderKey="orderKey" :orderBy="orderBy" :tableData='tableData' :ids="ids" :customList="customList" :showgift="showgift" :prepaymentdefaultaccount="prepaymentdefaultaccount" :AuthorityList='AuthorityList' ref='searchRef' @handleSearch="handleSearch" @modifySuc="modifySuc"/>
		<MainTable
			:size='size'
			:page='page'
			ref='mainTableRef'
			:tableData='tableData'
			:totalCount='totalCount'
			:sumData='sumData'
			:prepaymentdefaultaccount="prepaymentdefaultaccount"
			:showgift="showgift"
			:AuthorityList='AuthorityList'
			@modifySuc="modifySuc"
			@sortSearch="sortSearch"
			@handleSize='handleSizeChange'
			@handlePage='handlePageChange'
			@selectIds="selectIdsChange"
			@refreshMoney="refreshMoney"
		/>
	</div>
</template>

<script>
import Search from '@/components/payAdvance/Search.vue'
import MainTable from '@/components/payAdvance/MainTable.vue'
export default {
	name: 'payAdvance',
	components: {
		Search,
		MainTable
	},
	data () {
		return {
			AuthorityList: {
				'04_0002_0001_00': false,
				'04_0002_0002_00': false
			},
			page: 1,
			size: 20,
			tableData: [],
			totalCount: 0,
			sumData: {},
			ids: [],
			customList: [],
			disabledflag: '',
			keyword: '',
			customercategoryid: '0',
			customerlevelid: '0',
			minmoney: '',
			maxmoney: '',
			premoneytype: 0,
			prepaymentdefaultaccount: 0,
			orderKey: '',
			orderBy: '',
			showgift: 1,
			cusIds: [],
			filterArr: ['1278045867575746560', '1284199491759906816', '720926033251270656'],
			filterFlag: false
		}
	},
	beforeDestroy () {
		clearTimeout(this.timer)
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '8-2')
		const syscodeid = window.sessionStorage.getItem('entid')
		this.filterFlag = this.filterArr.includes(syscodeid)
		this.getCategory()
		this.checkSmallCategory()
		this.getAuthority('04_0002_0000_00')
		this.openPage()
	},
	methods: {
		selectIdsChange (ids) {
			this.ids = ids
		},
		saveSelect () {
			let params = {
				customerlevelid: this.customerlevelid,
				customercategoryid: this.customercategoryid,
				disabledflag: this.disabledflag,
				keyword: this.keyword,
				minmoney: this.minmoney,
				maxmoney: this.maxmoney,
				premoneytype: this.premoneytype,
				page: this.page,
				size: this.size
			}
			window.sessionStorage.setItem('payAdvanceSelect', JSON.stringify(params))
		},
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.prepaymentdefaultaccount = res.prepaymentdefaultaccount
				this.showgift = res.showgift
			})
		},
		refreshMoney (row, index) {
			let params = {
				id: row.customerid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/usablepremoney/refresh`,
				data: params
			}).then(res => {
				if (res.result) {
					if (res.data === 0) {
						this.tableData[index].refreshing = true
						clearTimeout(this.timer)
						this.cusIds.push(row.customerid)
						this.loop(this.cusIds)
					} else {
						this.tableData[index].usablepremoney = res.data
					}
				}
			})
		},
		loop (id) {
			this.timer = setTimeout(() => {
				this.refreshCheck(id)
				// this.loop(id)
			}, 1000)
		},
		refreshCheck (id) {
			let params = {
				customerIds: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/usablepremoney/refresh/result`,
				data: params,
				loading: false
			}).then(res => {
				if (res.result) {
					res.data.forEach(item => {
						const key = Object.keys(item).join()
						const value = Object.values(item).join()
						if (value !== null && value !== '') {
							this.tableData.forEach(e => {
								if (key === e.customerid) {
									e.refreshing = false
									e.usablepremoney = value
								}
							})
							const index = this.cusIds.findIndex(i => {
								// console.log(this.cusIds, i, value)
								return key === i
							})
							this.cusIds.splice(index, 1)
						}
					})
					if (this.cusIds.length === 0) {
						clearTimeout(this.timer)
					} else {
						this.loop(this.cusIds)
					}
				} else {
					this.$message.error(res.msg)
					clearTimeout(this.timer)
				}
			})
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		// 客户类别
		getCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result === true) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		openPage () {
			if (window.sessionStorage.getItem('payAdvanceSelect') && !this.filterFlag) {
				let data = JSON.parse(window.sessionStorage.getItem('payAdvanceSelect'))
				this.customerlevelid = data.customerlevelid
				this.customercategoryid = data.customercategoryid
				this.disabledflag = data.disabledflag
				this.keyword = data.keyword
				this.minmoney = data.minmoney
				this.maxmoney = data.maxmoney
				this.premoneytype = data.premoneytype
			}
			this.findOrderList()
		},
		sortSearch (data) {
			this.orderKey = data.orderKey
			this.orderBy = data.orderBy
			this.findOrderList()
		},
		modifySuc () {
			this.openPage()
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.findOrderList()
		},
		handlePageChange (value) {
			this.page = value
			this.findOrderList()
		},
		handleSearch (data) {
			this.customerlevelid = data.customerlevelid
			this.customercategoryid = data.customercategoryid
			this.disabledflag = data.disabledflag
			this.keyword = data.keyword
			this.minmoney = data.minmoney
			this.maxmoney = data.maxmoney
			this.premoneytype = data.premoneytype
			this.page = 1
			this.$refs.mainTableRef.pagination.page = 1
			if (!this.filterFlag) {
				this.saveSelect()
			}
			this.findOrderList()
		},
		findOrderList () {
			clearTimeout(this.timer)
			this.tableData = []
			let params = {
				page: this.page,
				size: this.size,
				keywordToPreMoney: this.keyword,
				disabledflag: this.disabledflag,
				customercategoryid: this.customercategoryid,
				customerlevelid: this.customerlevelid,
				premoneytype: this.premoneytype,
				minmoney: this.minmoney ? +this.minmoney : this.minmoney,
				maxmoney: this.maxmoney ? +this.maxmoney : this.maxmoney,
				orderby: this.orderKey,
				orderSort: this.orderBy
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/prepayment/list`,
				data: params
			}).then(res => {
				this.totalCount = res.data.recordCount
				res.data.recordList.forEach(e => {
					e.refreshing = false
				})
				this.tableData = res.data.recordList
				this.sumData = res.data.sumData
				// console.log(this.tableData)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	flex: 1
	display flex
	flex-direction column
	.shop-position {
		display flex
		align-items: center
		height: 50px
		min-height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-menu {
		height: 50px
		display flex
		position relative
		border-bottom: 1px solid #dce1fe
		li {
			height: 100%
			line-height: 49px
			margin-right: 60px
			font-size: 15px
			// font-weight: 700
			box-sizing:border-box
			cursor: pointer
			position: relative
			color: #595959
			&.active {
				color: var(--fx-primary-color)
				border-bottom: 2px solid var(--fx-primary-color)
			}
			span {
				position: absolute;
				width: 18px;
				height: 18px;
				line-height: 18px;
				border-radius: 50%;
				font-size: 11px;
				top: 5px;
				right: -18px;
				text-align: center;
				background-color: #EC4141;
				color: #fff;
				&.big-num {
					width: 28px;
					border-radius: 40px;
					right: -28px;
				}
			}
		}
		div {
			height: 100%
			line-height: 49px
			font-size: 14px
			font-weight: 700
			box-sizing:border-box
			position absolute;
			top: 0;
			right: 50px;
		}
	}
}
</style>
<style lang="stylus">
.order-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
